import { createContext, useState, useEffect } from 'react';
import { ethers } from 'ethers';
import { getTokens } from '../helpers/get-tokens';
import { getGraveYard } from '../helpers/get-grave-yard';
import { getTokenBalance } from '../helpers/get-tokenBalance';

const fetchGraveYards = async (tokens) => { 
  let newTokensArray = [];
  for(let i of tokens){ 
    // const response = await  getGraveYard(i.address); 
    // if(response.success){
    //   if(response.graveYardMaxHope){
    //     i.graveYardMaxHope = response.graveYardMaxHope;
    //   }
    // }
    i.graveYardMaxHope = 10000;
    newTokensArray.push(i);
  } 
  return newTokensArray;
}


const filterToken = async (token) => {
  if(token.symbol == 'CRD'){
    const response = await getTokenBalance(token.address);
    if(response.success){
     if(response.hasOwnProperty('balance')){
       if(parseFloat(response.balance) > 0){
         return true
       }
     }else{
       return false
     }
    }else{
     return false
    } 

  }else{
    return true;
  } 
}


export const TokenContext = createContext({
  tokens: [],
});

export const TokenProvider = ({ children }) => {
  const [tokens, setTokens] = useState([]);
  const [networkList, setNetworkList] = useState([]);
  const setNetworkTokens = async () => {
    let networkId = 1;
    if (window.ethereum) {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const { chainId } = await provider.getNetwork();
      networkId = chainId;
    } 
     if (networkId == '43113') {
      setNetworkList(['Avalanche FUJI', 'Ethereum', 'Base','Binance Smart Chain', 'Solana', ]);
    } else if (networkId == '43114') {
      setNetworkList(['Avalanche',  'Ethereum', 'Base', 'Binance Smart Chain', 'Solana',]);
    } else if (networkId == '56') {
      setNetworkList(['Binance Smart Chain',  'Ethereum', 'Base', 'Avalanche','Solana']);
    } else if (networkId == '97') {
      setNetworkList(['BSC - Testnet', 'Solana', 'Ethereum', 'Base', 'Avalanche']);
    } else if (networkId == '8453') {
      setNetworkList(['Base',  'Ethereum', 'Binance Smart Chain', 'Avalanche', 'Solana',]);
    } else if (networkId == 'solana') {
      setNetworkList(['Solana', 'Ethereum', 'Base', 'Binance Smart Chain', 'Avalanche']);
    }else{
      networkId = 1;
      setNetworkList(['Ethereum', "Base", 'Binance Smart Chain', 'Avalanche', 'Solana',]);
    }
 
    const networkTokens = getTokens(networkId.toString());
    const updatedTokens = await fetchGraveYards(networkTokens); 
    const filteredTokens =  [];
    for(let i of updatedTokens){
      if(await filterToken(i)){
        filteredTokens.push(i)
      }  
    }
     setTokens(filteredTokens); 
  };

  useEffect(() => {
    setNetworkTokens();
  }, []);

  const value = {
    tokens,
    setNetworkTokens,
    networkList
  };
  return (
    <TokenContext.Provider value={value}>{children}</TokenContext.Provider>
  );
};
